import { Component, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs';
import { logout } from 'app/store/auth/auth.action';
import {
  getTimesheetLogs,
  getTimesheetLogsCancel,
} from 'app/store/timesheet/timesheet.action';
import { Actions, ofType } from '@ngrx/effects';
import { AuthTypes } from 'app/store/auth/auth.type';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false,
})
export class DashboardComponent implements OnDestroy {
  user: any;

  constructor(
    private store: Store,
    private router: Router,
    private actions: Actions,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const data = localStorage.getItem('user');
    this.user = data ? JSON.parse(data) : null;
    this.store.dispatch(getTimesheetLogs());
  }

  onHandleLogout() {
    this.store.dispatch(logout());
    this.actions
      .pipe(
        ofType(AuthTypes.POST_AUTH_LOGOUT_SUCCESS),
        tap(() => {
          const companyID = this.route.snapshot.paramMap.get('companyID');
          this.router.navigate([`${companyID}`]);
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.store.dispatch(getTimesheetLogsCancel());
  }
}
